import React, { memo } from 'react';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

const SectionHeader = memo(function SectionHeader({ title, isExpanded, onToggle, maxMilestonesCount }) {
    return (
        <tr className="!tw-bg-slate-100">
            <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={onToggle}>
                <div className="tw-flex tw-items-center tw-gap-x-1.5">
                    <div>{title}</div>
                    <div>{isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                </div>
            </td>
            <td className="tw-cursor-pointer !tw-border-x-0" onClick={onToggle}></td>
            <td className="tw-cursor-pointer !tw-border-x-0" onClick={onToggle}></td>
            <td colSpan={maxMilestonesCount > 0 ? maxMilestonesCount * 2 + 4 : 8} className="tw-cursor-pointer !tw-border-l-0" onClick={onToggle}></td>
        </tr>
    );
});

export default SectionHeader;
